import { useQuery } from '@tanstack/react-query';

import { PREFIX_URL } from '@/api/config';
import { axios } from '@/lib/axios/axios';
import {
  ExtractFnReturnType,
  QueryConfig,
} from '@/lib/react-query/react-query';

const url = `${PREFIX_URL}/legal-center/consents`;

export type GetLegalConsentResponse = {
  consents: {
    termsAndConditions: boolean;
    privacyPolicy: boolean;
    cookies: boolean;
    newsletter: boolean;
  };
};

export const legalConsentQueryKey = ['legal-consent'];

export const getLegalConsent = (): Promise<GetLegalConsentResponse> => {
  return axios.get(url);
};

type QueryFnType = typeof getLegalConsent;

type UseGetLegalConsentOptions = {
  config?: QueryConfig<QueryFnType>;
};

export const useGetLegalConsent = ({ config }: UseGetLegalConsentOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: legalConsentQueryKey,
    queryFn: getLegalConsent,
    staleTime: Infinity,
    ...config,
  });
};
